import * as React from "react";
import * as _ from "lodash";
import * as qs from 'query-string';
import { connect, Dispatch } from "react-redux";
import MediaQuery from "react-responsive";
import { Table, Glyphicon, ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { AppActionCreators, SwapTrackerActionCreators, IApplicationState, IAppState, ISwapTrackerListResponse } from "@nkr/store/index";
import { ISwapTracker } from "@nkr/models/index";
import { DisplayType } from "@nkr/enums/index";
import { IRefreshInterval } from "../models";
import { SwapTrackerTableHeadWrapper, SwapTrackerTableBodyWrapper } from "../../styles";
import { FormControlWrapper } from "../../swaps/styles";
import SwapTrackerListRow from "./swap-tracker-list-row";
import SwapTrackerListCard from "./swap-tracker-list-card";

const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: "Disable" },
    { value: 300, label: "5 minutes" },
    { value: 600, label: "10 minutes" },
    { value: 3600, label: "30 minutes" },
    { value: 7200, label: "1 hour" }
];

interface IOwnProps {
    isOps: boolean,
    reloadCounts: Function
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void
    getSwaps: (isOps: boolean) => Promise<ISwapTrackerListResponse>,
    changeDisplay: (display: number) => void
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    list: ISwapTracker[],
    autoRefresh: number,
    loading: boolean,
    show: string,
    include: number,
    displayTimeZone: string
}

const initialState: IState = {
    list: [],
    autoRefresh: 0,
    loading: true,
    show: "ALL",
    include: 1,
    displayTimeZone: "DONORCENTER"
}

class SwapTrackerList extends React.Component<TProps, IState> {
    readonly state: IState = initialState;

    interval: any;

    componentDidMount() {
        let parsed = qs.parse(window.location.search);
        let include = parsed.include ? parseInt(parsed.include) : 1;
        let show = parsed.show ? parseInt(parsed.show) : 1;
        let autoRefresh = parsed.refresh ? parseInt(parsed.refresh) : 0;

        this.props.changeDisplay(show);

        this.setState({
            include,
            autoRefresh
        });

        this.getData();
    }

    getData = () => {
        return this.props.getSwaps(this.props.isOps).then((response: ISwapTrackerListResponse) => {
            this.setState({
                list: response.data.results,
                loading: false
            }, () => {
                return Promise.resolve();
            });
        });
    }

    getSortedList = () => {
        let sortedList = this.state.list.filter(item => {
            if (this.state.include == 1) {
                return true;
            } else {
                let offerAcceptance = item.offerAcceptance == 3;
                let sxmRecorded = item.sxmRecorded == 2 || item.sxmRecorded == 3;
                let finalXmComplete = item.finalXmComplete == 2 || item.finalXmComplete == 3;
                let logisticsCallScheduled = item.logisticsCallScheduled == 2 || item.logisticsCallScheduled == 3;
                let donorClearance = item.donorClearance == 2 || item.donorClearance == 3;
                let serologiesReturned = item.serologiesReturned == 2 || item.serologiesReturned == 3;
                let serologiesUploaded = item.serologiesRecorded == 2 || item.serologiesRecorded == 3;
                let kickoffCall = item.kickoffCall == 2 || item.kickoffCall == 3;
                let challengingLogistics = item.challengingLogistics == 3;

                return offerAcceptance || sxmRecorded || logisticsCallScheduled || donorClearance || serologiesReturned
                    || serologiesUploaded || kickoffCall || challengingLogistics || finalXmComplete;
            }
        });

        return sortedList;
    }

    getShowOptions = () => {
        let showOptions = this.props.isOps == false ?
            [
                { id: 1, description: 'Menus/Tabs' },
                { id: 2, description: 'Menus Only' },
                { id: 3, description: 'Tabs Only' },
                { id: 4, description: 'No Menus/Tabs' }
            ]
            :
            [
                { id: 1, description: 'Menus' },
                { id: 4, description: 'No Menus' }
            ];

        return showOptions;
    }

    refresh = () => {
        this.setState({
            loading: true
        }, () => {
            this.props.reloadCounts();

            return this.getData().then(() => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleAutoRefreshChange = (e: any) => {
        this.setState({
            autoRefresh: e.target.value
        }, () => {
            clearInterval(this.interval);

            if (this.state.autoRefresh > 0)
                this.interval = setInterval(() => this.refresh(), this.state.autoRefresh * 1000);
        });
    }

    handleDisplayChange = (e: React.FormEvent<any>) => {
        this.props.changeDisplay(parseInt(e.currentTarget.value));
    }

    handleIncludeChange = (include: any) => {
        this.setState({
            include
        });
    }

    render() {
        const sortedList = this.getSortedList();
        const marginTop = this.props.app.display == DisplayType.NoMenuNoTabs ? 10 : 0;
        const showOptions = this.getShowOptions();

        return (
            <>
                <MediaQuery minWidth={1112}>
                    <div className='container-fluid'>
                        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", height: 30, marginBottom: 20, marginTop }}>
                            <div style={{ flexBasis: "33%", fontSize: 28, fontWeight: 500 }}>
                                {(this.props.app.display == DisplayType.NoMenuNoTabs || this.props.app.display == DisplayType.MenuOnly) && (
                                    <>SWAP TRACKER</>
                                )}
                            </div>
                            <div style={{ flexBasis: "33%" }}>
                                {this.state.loading && (
                                    <div className="alert alert-info" style={{ marginBottom: 0, padding: 7.5, textAlign: "center" }}>Fetching swaps...</div>
                                )}
                            </div>
                            <div style={{ flexBasis: "33%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Include:</div>
                                <div>
                                    <ToggleButtonGroup type="radio" name="swaps" value={this.state.include} onChange={this.handleIncludeChange}>
                                        <ToggleButton type="radio" value={1} className={this.state.include == 1 ? "btn-primary btn-xs" : "btn-xs"}>All Swaps</ToggleButton>
                                        <ToggleButton type="radio" value={2} className={this.state.include == 2 ? "btn-primary btn-xs" : "btn-xs"}>Problem Swaps</ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                        </div>

                        <Table condensed striped>
                            <SwapTrackerTableHeadWrapper fontSize={14}>
                                <tr>
                                    <th>R#</th>
                                    <th>Swap<br />Mgr</th>
                                    <th>Swap</th>
                                    <th>Donor<br />Center</th>
                                    <th>Donor<br />Alias</th>
                                    <th>Recipient<br />Center</th>
                                    <th>Recipient<br />Alias</th>
                                    <th style={{ width: "6%" }}>Surgery<br />Date</th>
                                    <th>Status</th>
                                    <th style={{ width: "6%" }}>Offer<br />Acceptance</th>
                                    <th style={{ width: "6%" }}>Logistics</th>
                                    <th style={{ width: "6%" }}>Donor <br />Clearance</th>
                                    <th style={{ width: "6%" }}>Serologies<br />Returned</th>
                                    <th style={{ width: "6%" }}>Serology<br />Uploaded</th>
                                    <th style={{ width: "6%" }}>Final XM<br />Uploaded</th>
                                </tr>
                            </SwapTrackerTableHeadWrapper>
                            <SwapTrackerTableBodyWrapper fontSize={14}>
                                {sortedList.map((item, index) =>
                                    <SwapTrackerListRow
                                        key={'swap-tracker-row-' + index}
                                        item={item}
                                        index={index}
                                    />
                                )}
                            </SwapTrackerTableBodyWrapper>
                        </Table>

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, fontSize: 12 }}>
                            <div>
                                {sortedList.length} swaps ...
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                                <div style={{ marginRight: 10 }}>
                                    <FormControlWrapper
                                        value={this.props.app.display}
                                        componentClass="select"
                                        style={{ fontSize: 12 }}
                                        onChange={this.handleDisplayChange}
                                    >
                                        {showOptions.map(item =>
                                            <option value={item.id}>{item.description}</option>
                                        )}
                                    </FormControlWrapper>
                                </div>
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                                <div style={{ marginRight: 5 }}>
                                    <FormControlWrapper
                                        value={this.state.autoRefresh}
                                        componentClass="select"
                                        style={{ fontSize: 12 }}
                                        onChange={this.handleAutoRefreshChange}
                                    >
                                        {refreshIntervals.map((interval, index) =>
                                            <option key={index} value={interval.value}>{interval.label}</option>
                                        )}
                                    </FormControlWrapper>
                                </div>
                                <div>
                                    <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                                </div>
                            </div>
                        </div>
                    </div>
                </MediaQuery>

                <MediaQuery maxWidth={1111}>
                    <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 10 }}>SWAP TRACKER</div>

                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, fontSize: 12 }}>
                        <div>
                            {sortedList.length} swaps ...
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5 }}>Include:</div>
                            <div style={{ marginRight: 10 }}>
                                <FormControlWrapper
                                    value={this.state.include}
                                    componentClass="select"
                                    style={{ fontSize: 12 }}
                                    onChange={(e: React.FormEvent<any>) => this.handleIncludeChange(parseInt(e.currentTarget.value))}
                                >
                                    <option value='1'>All Swaps</option>
                                    <option value='2'>Problem Swaps</option>
                                </FormControlWrapper>
                            </div>
                        </div>

                        <div>
                            <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                        </div>
                    </div>

                    {this.state.loading && (
                        <div className="bg-info" style={{ marginBottom: 10, textAlign: "center", padding: 10 }}>Fetching swaps...</div>
                    )}

                    <div className="container-fluid" style={{ marginTop: 5 }}>
                        {sortedList.map((item, index) =>
                            <SwapTrackerListCard
                                key={index}
                                item={item}
                            />
                        )}
                    </div>
                </MediaQuery>
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSwaps: (isOps) => {
            return dispatch(SwapTrackerActionCreators.getSwaps(isOps));
        },
        changeDisplay: (display: number) => {
            dispatch(AppActionCreators.changeDisplay(display));
        }
    };
}

export default connect<{}, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(SwapTrackerList);
